import { render, staticRenderFns } from "./SelfServiceIndex.vue?vue&type=template&id=04d62b1c"
import script from "./SelfServiceIndex.vue?vue&type=script&lang=js"
export * from "./SelfServiceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports